module.exports = __webpack_public_path__ + "img/userprofile.b829010b.svg";